import { injectIntl } from "react-intl";
import { Link, withRouter } from "react-router-dom";

const GameDetailsControls = ({ location, match, intl: { formatMessage } }) => {
  return (
    <div className="game-details-controls-container">
      <Link
        to={{
          pathname: `/setup/${match.params.fixtureId}`,
          search: location.search,
        }}
        className={`link btn btn-sm btn-success btn-next btn-lg enabled-true`}
      >
        {formatMessage({
          id: "next",
          defaultMessage: "Next",
        })}{" "}
        <i className="fas fa-angle-right"></i>
      </Link>
    </div>
  );
};

export default injectIntl(withRouter(GameDetailsControls));
